<template>
    <div class="login-wrapper">
        <header-modular :back="'返回首页'" :url="o_info.morgurl || web_emof_member" :logo="o_info"></header-modular>
        <div class="login-container" :class="{other:o_mid}">
            <div class="flex align-center justify-end login-info-box">
                <div class="login-info">
                    <div class="classifys">
                        <div :class="{active:type === 0}" class="classify" @click="type = 0">账号登录</div>
                        <div :class="{active:type === 1}" class="classify" @click="type = 1">快捷登录</div>
                    </div>
                    <div v-show="type === 0" class="login">
                        <el-form ref="loginForm" :model="loginForm" :rules="login_rules" class="form">
                            <el-form-item prop="user_name">
                                <div class="login-input">
                                    <i class="iconfont icon-phone"></i>
                                    <el-input v-model="loginForm.user_name" class="login-item"
                                              placeholder="请输入账号"></el-input>
                                </div>
                            </el-form-item>
                            <el-form-item prop="password">
                                <div class="login-input">
                                    <i class="iconfont icon-password"></i>
                                    <el-input v-model="loginForm.password" class="login-item" placeholder="请输入密码" show-password
                                              type="password"></el-input>
                                    <router-link class="forget" to="/forget">忘记密码？</router-link>
                                </div>
                            </el-form-item>
                            <el-form-item class="self-center" label-width="0" ref="protocol" prop="protocol">
                                <div class="flex align-center">
                                    <el-checkbox-group v-model="loginForm.protocol">
                                        <el-checkbox label="agree">{{ '' }}</el-checkbox>
                                    </el-checkbox-group>
                                    <div class="protocol text-white">我已阅读并同意<span class="text-org cursor"
                                                                                     @click="showProtocol = true">《用户协议》</span></div>
                                </div>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div v-show="type === 1" class="login">
                        <el-form ref="phoneForm" :model="phoneForm" :rules="phone_rules" class="form">
                            <el-form-item prop="phone">
                                <div class="login-input">
                                    <i class="iconfont icon-phone"></i>
                                    <el-input v-model="phoneForm.phone" class="login-item" maxlength="11"
                                              placeholder="请输入手机号"></el-input>
                                </div>
                            </el-form-item>
                            <el-form-item prop="code">
                                <div class="login-input">
                                    <i class="iconfont icon-password"></i>
                                    <el-input v-model="phoneForm.code" class="login-item" maxlength="11"
                                              placeholder="请输入验证码"></el-input>
                                    <div class="code-text" @click="submitSMS">
                                        {{ codeText }} <span v-if="typeof codeText === 'number'">秒后重新发送</span>
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item class="self-center" label-width="0" ref="protocol" prop="protocol">
                                <div class="flex align-center">
                                    <el-checkbox-group v-model="phoneForm.protocol">
                                        <el-checkbox label="agree">{{ '' }}</el-checkbox>
                                    </el-checkbox-group>
                                    <div class="protocol text-white">我已阅读并同意<span class="text-org cursor"
                                                                                     @click="showProtocol = true">《用户协议》</span></div>
                                </div>
                            </el-form-item>
                        </el-form>
                    </div>
                    <!--                    <el-radio-group v-model="login_type">-->
                    <!--                        <el-radio :label="2">管理端</el-radio>-->
                    <!--                        <el-radio :label="1">会员端</el-radio>-->
                    <!--                        <el-radio :label="4">子管理员</el-radio>-->
                    <!--                        <el-radio :label="3">分会端</el-radio>-->
                    <!--                    </el-radio-group>-->
                    <div class="login-button margin-top-sm" @click="submitForm(type === 0 ? 'loginForm' : 'phoneForm')">
                        立即登录
                    </div>
                    <div class="login-icons margin-top-sm">
                        <div class="login-icon-t">
                            <i class="left"></i>
                            <span>使用其他方式登录</span>
                            <i class="right"></i>
                        </div>
                        <div class="login-img">
                            <div class="login-icon-wx" @click="wxOauth2Url">
                                <i class="iconfont icon-wx"></i>
                            </div>
                        </div>
                        <div style="text-align: center;color: #fff;margin-top: 10px">微信登录</div>

                    </div>
                </div>
                <div class="login-tip" v-if="o_mid">
                    <img class="tip-logo" src="../assets/img/bg_login_3.png">
                    <div class="tip-title">欢迎登录<br>{{ o_info.morgname }}<br>会员管理系统</div>
                </div>
            </div>
        </div>
        <slot-content-dialog width="80%" :dialog="showProtocol" title="用户协议" @watchState="watchState">
            <div slot="content" class="detail protocol-content" v-html="agreement"></div>
        </slot-content-dialog>
        <footer-simple-modular v-if="o_mid"></footer-simple-modular>
        <footer-modular v-else></footer-modular>
    </div>
</template>

<script>
import rules from '@/utils/rules'
import {getQueryString, TOAST, toast} from '@/utils/utils'
import {getMiniAgreement, phoneNewLogin, sendForgetSms, userNewLogin, wxNewLogin} from "@/api/login";
import FooterModular from "@/components/FooterLinkModular.vue";
import HeaderModular from "@/components/HeaderModular.vue";
import {getOrgLogo} from "@/api/login";
import {web_emof_member} from "@/utils/const";
import FooterSimpleModular from "@/components/FooterSimpleModular";
import SlotContentDialog from "@/components/SlotContentDialog.vue";

export default {
    name: "login",
    data() {
        return {
            web_emof_member: web_emof_member,
            type: 0,  //  登录类型
            loginForm: {
                user_name: '',
                password: '',
                protocol: [],
            },
            login_rules: {
                user_name: {required: true, message: '请输入账号', trigger: 'change'},
                password: [
                    {required: true, message: '请输入密码', trigger: 'change'}
                ],
                protocol: [
                    {required: true, message: '请先阅读并同意用户协议', trigger: 'change'}
                ],
            },
            phoneForm: {
                phone: '',
                code: '',
                protocol: [],
            },
            phone_rules: {
                phone: rules.tel,
                code: [
                    {required: true, message: '请输入验证码', trigger: 'change'}
                ],
                protocol: [
                    {required: true, message: '请先阅读并同意用户协议', trigger: 'change'}
                ],
            },
            login_type: 2,
            codeText: '获取验证码', // 验证码文字
            id: null, // 计时器id
            timeId: null, // 一次性计时器id
            code_sign: '',

            wx_code: '',
            //机构信息
            o_mid: '',
            o_info: '',

            agreement:'',
            showProtocol:false
        }
    },
    created() {
        this.o_mid = this.$route.query.mid || this.$store.state.o_mid || ''
        if (this.o_mid) {
            this.getOrgLogo()
        }
        this.wx_code = getQueryString('code')
        if (this.wx_code) {
            this.wxLogin()
        }
        this.getAgreement()
    },
    components: {SlotContentDialog, FooterSimpleModular, FooterModular, HeaderModular},
    methods: {
        async getOrgLogo() {
            await window.localStorage.setItem('o_mid', JSON.stringify(this.o_mid))
            this.$store.state.o_mid = this.o_mid
            let _data = await getOrgLogo(this.o_mid)
            this.o_info = _data.data
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.login(formName)
                }
            });
        },
        async login(formName) {
            const loading = this.$loading({
                lock: true,
                text: '登录中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let _data = formName === 'loginForm' ? await userNewLogin(this.loginForm.user_name, this.loginForm.password) :
                formName === 'phoneForm' ? await phoneNewLogin(this.phoneForm.phone, this.phoneForm.code)
                    : await wxNewLogin(this.wx_code, 0)
            loading.close();
            if (_data.status === 200) {
                this.$store.state.userAll = _data.data
                await window.localStorage.setItem('userAll', JSON.stringify(_data.data))
                this.$router.replace('/choice')
            } else {
                history.pushState('', '', window.location.origin + window.location.pathname)
            }

        },
        submitSMS() {
            this.$refs.phoneForm.validateField('phone', (valid) => {
                if (!valid) {
                    this.sendCode()
                }
            })
        },
        async sendCode() {
            if (this.codeText === '获取验证码' || this.codeText === '重新发送') {
                const loading = this.$loading({
                    lock: true,
                    text: '正在发送...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let _data = await sendForgetSms(this.phoneForm.phone, this.type)
                loading.close();
                if (_data.status === 200) {
                    this.code_sign = _data.data
                    let codeNum = 60
                    this.id = setInterval(() => {
                        if (codeNum === 0) {
                            this.codeText = '重新发送'
                            clearInterval(this.id)
                            return
                        }
                        if (typeof codeNum === 'number') {
                            codeNum--
                            this.codeText = codeNum
                        }
                    }, 1000)
                } else {
                    this.codeText = '重新发送'
                    clearInterval(this.id)
                }
            }
        },
        // 微信登录
        wxLogin() {
            this.login('wxForm')
        },
        wxOauth2Url(){
            if (!this.loginForm.protocol.length && this.type === 0) return toast('请先阅读并同意用户协议', TOAST.error)
            if (!this.phoneForm.protocol.length && this.type === 1) return toast('请先阅读并同意用户协议', TOAST.error)
            window.open(`https://open.weixin.qq.com/connect/qrconnect?appid=wx2f662cfbfdc8da48&redirect_uri=https://hygl.emof.cn/vw/login&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect`)
        },
        async getAgreement() {
            let _data = await getMiniAgreement()
            this.agreement = _data.data.data
        },
        watchState() {
            this.showProtocol = false
        }
    },
    filters: {},
    watch: {
        type() {
            this.$refs.phoneForm.clearValidate()
            this.$refs.loginForm.clearValidate()
        }
    },
}
</script>

<style lang="scss" scoped>
::v-deep{
    .el-checkbox__input.is-checked .el-checkbox__inner{
        background-color: #ffa628;
        border-color: #ffa628;
    }
}
.login-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    min-height: 100vh;

    .login-container {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        flex: 1;
        width: 100%;
        background-size: cover;
        background: url(../assets/img/bg_login.png) no-repeat center;

        &.other {
            background: url(../assets/img/bg_login_2.png) no-repeat center;

        }

        .login-info-box {
            width: 1200px;
            margin: 0 auto;
            height: 740px;
            position: relative;

            .login-tip {
                height: 550px;
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);

                .tip-logo {
                    width: 547px;
                }

                .tip-title {
                    position: absolute;
                    font-size: 28px;
                    line-height: 2;
                    letter-spacing: 1px;
                    color: #0a2240;
                    bottom: 0;
                }
            }

            .login-info {
                display: flex;
                flex-direction: column;
                width: 400px;
                background-color: #0a2240;
                border-radius: 10px;
                position: relative;
                padding: 45px;
                z-index: 1;

                &:after {
                    position: absolute;
                    width: 561px;
                    height: 357px;
                    background: rgba(10, 34, 64, .1);
                    border-radius: 10px;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    content: '';
                    z-index: -1;
                }

                &:before {
                    position: absolute;
                    width: 489px;
                    height: 450px;
                    margin: 0 auto;
                    background: rgba(10, 34, 64, .3);
                    border-radius: 10px;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    content: '';
                    z-index: -1;
                }

                .form {
                    margin-top: 50px;

                    .login-input {
                        display: flex;
                        align-items: center;
                        height: 48px;
                        border-radius: 4px;
                        border: solid 1px #ffffff;
                        padding: 0 20px;

                        i {
                            display: block;
                            text-align: center;
                            font-size: 20px;
                            color: #ffffff;
                        }

                        .login-item {
                            flex: 1;
                            color: #ffffff;
                        }

                        .forget {
                            color: #fff;
                        }

                        .code-img {
                            width: 116px;
                            height: 43px;
                            background: #fff;
                        }

                        .code-text {
                            flex-shrink: 0;
                            text-align: center;
                            line-height: 41px;
                            color: #fff;
                            cursor: pointer;
                        }
                    }
                }

                .login-button {
                    width: 100%;
                    height: 46px;
                    background-image: linear-gradient(168deg,
                        #ffb400 0%,
                        #fc7802 100%),
                    linear-gradient(
                            #ff9600,
                            #ff9600);
                    background-blend-mode: normal,
                    normal;
                    border-radius: 10px;
                    text-align: center;
                    font-size: 18px;
                    line-height: 46px;
                    color: #ffffff;
                    cursor: pointer;
                    user-select: none;
                }

                .login-icons {
                    .login-icon-t {
                        font-size: 12px;
                        color: #999;
                        height: 36px;
                        text-align: center;
                        line-height: 36px;
                        margin-bottom: 30px;

                        .left {
                            width: 100px;
                            border-bottom: 1px solid rgba(255, 255, 255, .4);
                            float: left;
                            margin-top: 18px;
                        }

                        .right {
                            width: 100px;
                            border-bottom: 1px solid rgba(255, 255, 255, .4);
                            float: right;
                            margin-top: 18px;
                        }
                    }

                    .login-img {
                        width: 45px;
                        margin: 0 auto;

                        .login-icon-wx {
                            display: inline-block;
                            width: 45px;
                            height: 45px;
                            background: #fff;
                            border-radius: 100%;
                            text-align: center;
                            line-height: 45px;

                            i {
                                font-size: 30px;
                                color: #0a2240;
                            }
                        }
                    }
                }

                .classifys {
                    display: flex;
                    margin-top: 15px;
                    position: relative;

                    &:before {
                        position: absolute;
                        width: 308px;
                        height: 1px;
                        background-color: #ffffff;
                        opacity: 0.4;
                        content: '';
                        bottom: -15px;
                        left: 0;
                    }

                    &:after {
                        position: absolute;
                        width: 1px;
                        height: 21px;
                        background-color: #ffffff;
                        opacity: 0.4;
                        content: '';
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                    }

                    .classify {
                        font-size: 18px;
                        text-align: center;
                        flex: 1;
                        color: #ffffff44;
                        cursor: pointer;

                        &.active {
                            color: #ffffff;
                            position: relative;

                            &:before {
                                position: absolute;
                                width: 76px;
                                height: 2px;
                                background-color: #ffffff;
                                content: '';
                                bottom: -15px;
                                left: 50%;
                                transform: translateX(-50%);
                            }
                        }
                    }
                }
            }
        }

    }
}
</style>
